import { render, staticRenderFns } from "./AdditionalChargesSection.vue?vue&type=template&id=2318ab96"
import script from "./AdditionalChargesSection.vue?vue&type=script&lang=js"
export * from "./AdditionalChargesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports